import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, hasBackend } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      if (!hasBackend) { setUser(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        if (alive) setUser(data);
      } catch {
        try {
          const { data } = await api.post("/auth/refresh");
          if (alive) setUser(data);
        } catch {
          if (alive) setUser(false);
        }
      }
    };
    check();
    return () => { alive = false; };
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } finally { setUser(false); }
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
